import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { getForaHotels } from '../queries';

const useForaStore = create(
  devtools((set) => ({
    list: [],
    error: null,
    isLoading: false,
    fetch: async (obj) => {
      console.log('fetch', obj);
      return set({ cityName: obj });
    },
    search: async (obj) => {
      console.log('search', obj);
      try {
        set({ isLoading: true, list: [] });
        const req = await getForaHotels(obj);
        const res = await req.json();
        if (req.status >= 400 && req.status < 600) {
          set({ error: res, isLoading: false });
        } else {
          set({
            list: res.results,
            isLoading: false,
          });
        }
      } catch (error) {
        set({ error, isLoading: false });
      }
    },
    setPage: async (obj) => {
      try {
        set({ isLoading: true });
        const req = await getForaHotels(obj);
        const res = await req.json();
        if (req.status >= 400 && req.status < 600) {
          set({ error: res, isLoading: false });
        } else {
          set((state) => ({
            list: [...state.list, ...res.results],
            isLoading: false,
          }));
        }
      } catch (error) {
        set({ error, isLoading: false });
      }
    },
  })),
  'ForaStore' // Name of the store for the Redux DevTools extension
);
export default useForaStore;
